module.exports = "query GetAllGroups {\n  groups(limit: 1000000) {\n    ...GroupFragment\n  }\n}\n"